import { Theme, InputAdornment } from '@mui/material';
import { createStyles, makeStyles } from '@mui/styles';
import {
  CcfDeboucedInput,
  CcfSearchIcon,
  CcfTypography,
} from '@nice-ccf/ui-controls';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ccfConversationsActions,
  getAgentGroups,
  getAgents,
} from '../+state/ccf-conversations.slice';
import { agentsData } from '../mock-data/agent-conversations-mock-data';
import { getAppSpaceRatio } from '../../../global.app.slice';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    header: {
      padding: '6px',
      // borderRight: '1px solid #e3e9ee',
      opacity: '1',
      width: '40%',
    },
    textField: {
      background: theme.palette.background.paper,
      '& > .MuiInputBase-root': {
        height: 32,
        fontSize: 'small',
      },
    },
    captionText: {
      fontFamily: 'Open Sans',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '12px',
      lineHeight: '16px',
      color: '#333333',
    },
  })
);

/**
 * Component for Conversation search
 * @example <ConversationSearch />
 * @returns
 */
export const ConversationAppSearch = ({
  showSearchBox,
}: {
  showSearchBox: boolean;
}) => {
  const styles = useStyles();
  const dispatch = useDispatch();
  const [searchTxt, setSearchTxt] = useState('');
  const agents = useSelector(getAgents);
  const agentGroups = useSelector(getAgentGroups);
  const [agentsCopy, setAgentsCopy] = useState([]);
  const [agentGroupsCopy, setAgentGroupsCopy] = useState([]);
  const { updateSelectedAgent, updateAgentGroups, updateAgents } =
    ccfConversationsActions;

  useEffect(() => {
    if (!searchTxt) {
      setAgentsCopy(agents);
      setAgentGroupsCopy(agentGroups);
    }
  }, [agents, agentGroups]);
  /**
   * Handler for search agent
   * @example searchAgentHandler()
   */
  const searchAgentHandler = (e: any) => {
    const searchText = e.target.value.toLowerCase();
    setSearchTxt(searchText);

    /**
     * Function to filter items
     * @example filterItems()
     */
    const filterItems = (items: any[], key: string) =>
      items.filter((item) => item.name.toLowerCase().startsWith(searchText));

    if (searchText) {
      const filteredAgents = filterItems(agentsCopy, 'name');
      const filteredAgentGroups = filterItems(agentGroupsCopy, 'name');
      dispatch(updateAgents({ filteredAgents, type: 'filter' }));
      dispatch(updateAgentGroups({ filteredAgentGroups, type: 'filter' }));
    } else {
      dispatch(updateAgents({ filteredAgents: agentsCopy, type: 'filter' }));
      dispatch(
        updateAgentGroups({
          filteredAgentGroups: agentGroupsCopy,
          type: 'filter',
        })
      );
      dispatch(
        updateSelectedAgent({ agent: agentsData[0], type: 'favourite' })
      );
    }
  };

  return (
    <section className={styles.header}>
      {showSearchBox ? (
        <CcfDeboucedInput
          size="small"
          style={{
            background: 'white',
          }}
          value={searchTxt}
          onChange={(e) => searchAgentHandler(e)}
          className={styles.textField}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CcfSearchIcon />
              </InputAdornment>
            ),
          }}
          placeholder="Search"
          variant="outlined"
          fullWidth
          delay={1500}
        />
      ) : (
        <div style={{ height: '33px', display: 'flex', alignItems: 'center' }}>
          <CcfTypography className={styles.captionText}>
            Currently Online |12
          </CcfTypography>
        </div>
      )}
    </section>
  );
};
